import { render, staticRenderFns } from "./UsuariosProfile.vue?vue&type=template&id=e700a5ec&scoped=true&"
import script from "./UsuariosProfile.vue?vue&type=script&lang=js&"
export * from "./UsuariosProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e700a5ec",
  null
  
)

export default component.exports